var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppHeader'),_c('main',[_c('v-container',{staticClass:"router-views"},[_c('transition',{attrs:{"origin":"center","mode":"out-in","duration":250}},[_c('router-view')],1)],1)],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }